var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00028 1.85718C8.00028 1.30489 7.55256 0.857178 7.00028 0.857178C6.44799 0.857178 6.00028 1.30489 6.00028 1.85718V6.00003H1.85742C1.30514 6.00003 0.857422 6.44775 0.857422 7.00003C0.857422 7.55232 1.30514 8.00003 1.85742 8.00003H6.00028V12.1429C6.00028 12.6952 6.44799 13.1429 7.00028 13.1429C7.55256 13.1429 8.00028 12.6952 8.00028 12.1429V8.00003H12.1431C12.6954 8.00003 13.1431 7.55232 13.1431 7.00003C13.1431 6.44775 12.6954 6.00003 12.1431 6.00003H8.00028V1.85718Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdd);
export default __webpack_public_path__ + "static/media/ic_add.8ac0a1cd454739620bc9ba58606c33d0.svg";
export { ForwardRef as ReactComponent };